import { render, staticRenderFns } from "./PendingQueueSection.vue?vue&type=template&id=3ea4cff3&scoped=true&"
import script from "./PendingQueueSection.vue?vue&type=script&lang=js&"
export * from "./PendingQueueSection.vue?vue&type=script&lang=js&"
import style0 from "./PendingQueueSection.vue?vue&type=style&index=0&id=3ea4cff3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea4cff3",
  null
  
)

export default component.exports